import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/protein-intake-calculator',
  component: () => import('../../routes/ProteinIntakeCalculator.svelte'),
  card: {
    id: 'protein-intake-calculator',
    title: 'Protein Intake Calculator',
    description: 'Calculate your optimal daily protein intake based on lean body mass and activity level.',
    icon: 'fitness_center',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/protein-intake-calculator',
    category: 'Weight & Nutrition',
  },
  seo: {
    title: 'Protein Intake Calculator – Daily Protein Needs by LBM',
    description: 'Free protein intake calculator. Calculate optimal daily protein intake based on lean body mass and activity level. Based on ISSN sports nutrition guidelines.',
  },
};

export default meta;
